module.exports = __webpack_public_path__ + "static/office_small-267bd710fe1df16f8465f7e7ccbb90d1.jpg";